export default "__VITE_ASSET__1xrFg8Tm__"